import React from "react";
import { RoleTag } from "./RoleTag";
import { graphql, useFragment } from "react-relay";
import { AHText, Box } from "arkh";
import { StoreUserRoleAndEmailTag_storeUser$key } from "./__generated__/StoreUserRoleAndEmailTag_storeUser.graphql";

export function StoreUserRoleAndEmailTag(props: {
  storeUser: StoreUserRoleAndEmailTag_storeUser$key;
}) {
  const storeUser = useFragment(
    graphql`
      fragment StoreUserRoleAndEmailTag_storeUser on StoreUser {
        role
        user {
          email
        }
      }
    `,
    props.storeUser
  );
  return (
    <Box
      style={{
        flexDirection: "row",
        alignItems: "center",
        borderWidth: 1,
        alignSelf: "flex-start",
      }}
      cornerRadius="large"
      space="xxsmall"
      borderColor="border-primary"
    >
      <RoleTag role={storeUser.role} />
      <AHText type="info-small" spaceHorizontal="small" color="text-secondary">
        {storeUser.user.email}
      </AHText>
    </Box>
  );
}
